import React, { Component } from "react";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import { mapToObjectDDL } from "../../../../common/mapper";

class DataCustomerOwnerTab extends Component {
  render() {
    return (
      <>
        <SimpleInput
          id="input_text_nama_pembeli"
          name="namaPembeli"
          label={this.props.type==='pemilik' ? "Nama Pemilik" : "Nama Pembeli"}
          readOnly
          value={this.props.data?.namaPembeli}
        />
        <SimpleInput
          id="input_text_nik"
          name="nik"
          label="NIK"
          readOnly
          value={this.props.data?.nik}
        />
        <SimpleInput
          id="input_text_no_hp"
          name="noHP"
          label="No. HP"
          readOnly
          value={this.props.data?.nomorHP}
        />
        <SimpleInput
          id="input_text_email"
          name="email"
          label="Email"
          readOnly
          value={this.props.data?.email}
        />
        <SimpleTextArea
          id="input_text_alamat"
          name="alamat"
          label="Alamat"
          readOnly
          value={this.props.data?.alamat}
        />
        <SimpleInput
          id="input_text_no_kk"
          name="noKK"
          label="No. KK"
          readOnly
          value={this.props.data?.nomorKK}
        />
        <SimpleInput
          id="input_text_npwp"
          name="npwp"
          label="NPWP"
          readOnly
          value={this.props.data?.npwp}
        />
        <SimpleDDL
          id="select_options_province"
          name="province"
          label="Provinsi"
          box="search"
          readOnly
          value={this.props.ddlValues.provinceOptions}
        />
        <SimpleDDL
          id="select_options_kota"
          name="kota"
          label="Kota"
          box="search"
          readOnly
          value={this.props.ddlValues.cityOptions}
        />
        <SimpleDDL
          id="select_options_kecamatan"
          name="kecamatan"
          label="Kecamatan"
          box="search"
          readOnly
          value={this.props.ddlValues.kecamatanOptions}
        />
        <SimpleDDL
          id="select_options_kelurahan"
          name="kelurahan"
          label="Kelurahan"
          box="search"
          readOnly
          value={this.props.ddlValues.kelurahanOptions}
        />
        <SimpleDDL
          id="select_options_kode_pos"
          name="kodePos"
          label="Kode Pos"
          box="search"
          readOnly
          value={mapToObjectDDL(this.props.data?.zipcode, this.props.data?.zipcode)}
        />
      </>
    );
  }
}

export default DataCustomerOwnerTab;
